let host = ''
let domain = ''
//const host = 'https://apiuat.absolutnights.cn'
//const domain = 'https://uat.absolutnights.cn'
if (window.location.hostname == 'absolutnights.cn') {
  host = 'https://api.absolutnights.cn'
  domain = 'https://absolutnights.cn'
} else {
  host = 'https://apiuat.absolutnights.cn'
  domain = 'https://uat.absolutnights.cn'
}

const config = {
  host,
  domain,

  // 短信接口 post type:1表示注册时发的,2表示登录时发的
  smsUrl: `${host}/sms/send`,

  // 微信授权 post
  wxAuthUrl: `${host}/customers/wx-auth-url`,

  // 注册接口 post
  regUrl: `${host}/customers/register`,

  // 登录接口 post
  loginUrl: `${host}/customers/login`,

  // 微信登录接口 post
  wxloginUrl: `${host}/customers/wx-login`,

  // pc登录接口 post
  pcloginUrl: `${host}/customers/pc-login`,

  // 微信获取用户信息 post
  wxUserInfoUrl: `${host}/customers/wx-user-info`,

  // pc获取用户信息 post
  pcUserInfoUrl: `${host}/customers/pc-user-info`,

  // 微信jssdk接口 post
  //wechatJsUrl: `${host}/customers/jssdk`,
  wechatJsUrl: `${host}/customers/wx-sign`,

  // 活动列表 get
  eventsUrl: `${host}/events`,

  // 活动点赞 post
  eventsLikeUrl: `${host}/events/like`,

  // 城市列表 get
  citiesUrl: `${host}/cities`,

  // 俱乐部分类 get
  categoriesUrl: `${host}/categories`,

  // 俱乐部详情 get
  clubsUrl: `${host}/clubs`,

  // 大使列表 get
  ambassadorsUrl: `${host}/ambassadors`,

  // 精彩瞬间 get
  galleriesListUrl: `${host}/galleries/list`,

  // 精彩瞬间详情 get
  galleryDetailUrl: `${host}/galleries`,

  // fundings post为提交，get为获取
  fundingsUrl: `${host}/fundings`,

  // 状态 get
  fundingsTotalUrl: `${host}/fundings/total`,

  // 我的申请 get
  submissionsUrl: `${host}/fundings/my`,

  // 投票 post 需要加id
  projectVoteUrl: `${host}/fundings/vote`,

  // 评论 post
  commentUrl: `${host}/fundings/comment`,

  // 百城城市列表 get
  fundingCitiesUrl: `${host}/fundings/cities`,

  // 瓶子列表 get
  bottlesUrl: `${host}/bottles`,

  // 瓶子城市 get
  bottlesCitiesUrl: `${host}/bottles/cities`,

  // tags get
  tagsUrl: `${host}/tags`,

  // 上传 post
  uploadUrl: `${host}/uploads`,

  // 判断是否关注 0 未关注 1 关注
  subscribeUrl: `${host}/events/subscribe`,

  // topics 主题 get为获取
  topicsUrl: `${host}/topics`,

  // topics 当前主题 get为获取
  topicsLatestUrl: `${host}/topics/latest`,

  // topics 即将到来主题 get为获取
  topicsFutureUrl: `${host}/topics/future`,

  // plans post为提交，get为获取
  plansUrl: `${host}/plans`,

  // 投票 post 需要加id
  planVoteUrl: `${host}/plans/vote`,

  // 评论 post
  planCommentUrl: `${host}/plans/comment`,

  // 我的 get
  plansSubmissionsUrl: `${host}/plans/my`,

  // 重造活动列表 get获取 post添加
  replansUrl: `${host}/replans`,

  // 重造活动城市列表 get获取
  replansCitiesUrl: `${host}/replans/cities`,

  // 重造活动评论列表 get获取 post添加
  replanCommentUrl: `${host}/replans/comment`,

  // 重造投票 post
  replanVoteUrl: `${host}/replans/vote`,

  // 我的列表 post
  replanMyUrl: `${host}/replans/my`,

  // 我的投票 post
  replanMyVoteUrl: `${host}/replans/myvote`,

  // 重造百城活动 post添加
  replanHundredUrl: `${host}/replans/hundred`,

  // 是否可以重造 post
  replanCreatecheckUrl: `${host}/replans/createcheck`,

  // 重造计划概况 get
  replanOverviewUrl: `${host}/replans/overview`,

  // 百城挑一赢家 get
  replanWinnerUrl: `${host}/replans/winner`,

  // 百城赢家列表 get
  replanCityTopUrl: `${host}/replans/citytop`,

  //ugc
  ugcUrl: `${host}/ugcs`,

  //ugc plans get
  ugcPlanUrl: `${host}/ugcs/plans`,

  //ugc vote post
  ugcVoteUrl: `${host}/ugcs/vote`,
  myUgcVoteUrl: `${host}/my-ugcs/vote`,

  //ugc comment
  ugcCommentUrl: `${host}/ugcs/comment`,
  myUgcCommentUrl: `${host}/my-ugcs/comment`,
  delMyUgc: `${host}/my-ugcs/delete-ugc`,

  // My
  myProfile: `${host}/person-centers/my-profile`,
  myUgc: `${host}/my-ugcs`,
  // avatar
  myAvatarUrl: `${host}/person-centers/update-avatar`,
  // nickname
  myNicknameUrl: `${host}/person-centers/update-nickname`,

  //fundingnew
  myPlans: `${host}/person-centers/my-plans`,
  newPlansUrl: `${host}/night-plans`,
  planStatisticsUrl: `${host}/night-plans/statistics`,
  newReplanVoteUrl: `${host}/night-plans/vote`,
  newCommentUrl: `${host}/night-plans/comment`,
  myLikePlans: `${host}/person-centers/my-like-plans`,
  updateGender: `${host}/person-centers/update-gender`,
  updateBirthday: `${host}/person-centers/update-birthday`,
  updateCity: `${host}/person-centers/update-city`,
  updateHobby: `${host}/person-centers/update-hobby`,
  updateTopic: `${host}/person-centers/update-topic`,
  sendBehavior: `${host}/customer-behaviors/send-behavior`,
  videoUrl: `${host}/night-plans/fetch-redirect-url`,
  // 日历
  calendarUrl: `${host}/night-plans/calendar`,

  //check status
  planStatusUrl: `${host}/night-plans/check-status`,

  //calendar plan
  winnerPlanUrl: `${host}/night-plans/show-plan`,

  //plan sign up
  planSignUpUrl: `${host}/night-plans/sign-up`,

  //check profile
  checkProfileUrl: `${host}/person-centers/check-profile`,

  //my join plan list
  myJoinPlansUrl: `${host}/person-centers/my-join-plans`,

  //my join plan
  myJoinPlanUrl: `${host}/person-centers/show-plan`,
  // 赛博分享排名
  cyberRank: `${host}/cyber-games/get-rank`,
  // 赛博急先锋
  cyberShow: `${host}/night-plans/show-cyber`,
  // 分享
  sharePlan: `${host}/cyber-games/add-share-plan`,
}

// module.exports = config
export default config



// WEBPACK FOOTER //
// ./src/config.js